import React from 'react';
import { BodyRegular, BodySmall } from "./fonts/Body";
import { tablet } from "./MediaQueries";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Pill } from "./Pill";
import Colours from "./Colours";

export function ProgressionLine(props: Props) {
  const {bgColour, title, fgColour, showPillSummary, percentage, translationTitle} = props;
  const {t} = useTranslation();

  return (
    <UsageVisualContainer className={'progressionLine'}>
      {(title || translationTitle) && <BodyRegular weight={600} style={{marginBottom: -10}} className={"whereaboutsUsage__title"}>{!!props.title ? props.title : t(translationTitle || '')}</BodyRegular>}
      <LineContainer>
        <LineBarBackground colour={bgColour}>
          <LineBarFill percentage={percentage * 100} colour={fgColour} />
        </LineBarBackground>
        {showPillSummary && <Pill className={'progressionLine__pill'} colour={bgColour} backgroundColour={bgColour}>
          <BodySmall colour={Colours.black} weight={600}>{t('reports-page.office-usage.capacity', {capacity: Math.round(percentage * 100)})}</BodySmall>
        </Pill>}
      </LineContainer>
    </UsageVisualContainer>
  )
}

interface Props {
  bgColour: string;
  translationTitle?: string;
  title?: string;
  fgColour: string;
  percentage: number;
  showPillSummary?: boolean;
}

const UsageVisualContainer = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  padding-right: 0;
  padding-left: 0;
  margin-bottom: 16px;
  p {
    margin-bottom: 0;
  }
  @media (${tablet}) {
    padding-right: 52px;
    width: 80%;
    padding-left: 32px;
    p {
      margin-bottom: 4px;
    }
  }
`
const LineBarBackground = styled.div<any>`
  width: 60%;
  height: 8px;
  position: relative;
  background-color: ${props => props.colour};
  overflow: hidden;
  border-radius: 40px;
  @media (${tablet}) {
    width: 100%;
  }
`

const LineBarFill = styled.div<any>`
  width: ${props => `${props.percentage}%`};
  background-color: ${props => props.colour};
  height: 100%;
  position: absolute;
`

const LineContainer = styled.div<any>`
  display: flex;
  align-items: center;
  .progressionLine__pill {
    width: 134px;
    max-width: 154px;
    margin-left: 16px;
    padding: 2px 8px 2px 16px;
    p {
      color: ${Colours.black};
      margin: 0;
      line-height: 22px;
    }
    @media (${tablet}) {
      p {
        margin-bottom: 4px;
      }
      width: 146px;
    }
  }
`
